import { PremiumStatus } from 'multirpc-sdk';
import { createSelector } from 'reselect';

import { RootState } from 'store';
import { selectIsLoggedIn } from 'modules/auth/store/selectors';
import { selectTeamAccountAddress } from 'modules/account/store/selectors';
import {
  selectJWTs,
  selectJWTsLoading,
} from 'domains/jwtToken/action/fetchJWTs';

import {
  selectAccountStatus as selectAccountStatusData,
  selectAccountStatusState,
} from '../actions/fetchAccountStatus';

export const selectAccountStatus = createSelector(
  selectAccountStatusData,
  ({ status }) => status,
);

export const selectAccountStatusError = createSelector(
  selectAccountStatusState,
  ({ error }) => error,
);

export const selectAccountStatusLoaded = createSelector(
  selectAccountStatusState,
  ({ isSuccess }) => isSuccess,
);

export const selectIsFreemium = createSelector(
  selectAccountStatusData,
  selectIsLoggedIn,
  ({ isFreemium }, isLoggedIn) => isLoggedIn && isFreemium,
);

export const selectIsPremium = createSelector(
  selectAccountStatusData,
  selectIsLoggedIn,
  ({ isFreemium }, isLoggedIn) => isLoggedIn && !isFreemium,
);

export const selectIsEnterprise = createSelector(
  selectAccountStatusData,
  ({ isEnterprise }) => isEnterprise,
);

export const selectIsInactive = createSelector(
  selectAccountStatus,
  status => status === PremiumStatus.INACTIVE,
);

export const selectIsPartner = createSelector(
  selectIsLoggedIn,
  selectTeamAccountAddress,
  selectJWTsLoading,
  (state: RootState) => state,
  // eslint-disable-next-line max-params
  (isLoggedIn, group, isLoading, state) => {
    if (!isLoggedIn || isLoading) return false;

    const jwts = selectJWTs(state, { group });

    if (!jwts?.length) return false;

    const mainJWT = jwts.find(jwt => jwt.index === 0) || jwts[0];

    return Boolean(mainJWT?.partnerChains?.length);
  },
);
